/* eslint-disable react/no-array-index-key, react/jsx-one-expression-per-line */
import React from 'react'
import { t, Trans } from '@lingui/macro'

import ImageTextSection from '../../../../components/common/ImageTextSection'
import addEmail from '../../../../../assets/instructions/add_email.png'

const EMAIL_ATTRIBUTE = 'email_address'

const heading = t`Add an email address`
const toggled = false
const canBeToggled = true
const paragraphs = [
  <Trans><p>Tap <b>Personal details</b> on the home screen and select <b>Email.</b></p></Trans>,
  <Trans><p>Tap <b>Add email,</b> add your email address and select your email type.</p></Trans>,
  <Trans><p>A verification code will be sent to that email. If you don’t receive an email, check your Spam folder.</p></Trans>
]
const imgSrc = addEmail

const isShown = attributeNames => attributeNames.includes(EMAIL_ATTRIBUTE)

const EmailStep = () => (
  <ImageTextSection
    contentToggled={toggled}
    contentToggleEnabled={canBeToggled}
    {...(imgSrc && { imgSrc })}
  >
    <h6 className="instructions-section__header">
      <Trans id={heading} />
    </h6>
    { paragraphs.map((p, key) => React.cloneElement(p, { key }))}
  </ImageTextSection>
)

EmailStep.isShown = isShown

export default EmailStep
